import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("canvas", { id: "c" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", {
  id: "status",
  class: "error"
}, null, -1)
const _hoisted_3 = { class: "container-fluid page-dashboard" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "elections-wrapper col-lg-12" }
const _hoisted_6 = {
  id: "elections-page-instructions-wrapper",
  class: "section-wrapper"
}
const _hoisted_7 = { id: "section-title" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 0,
  id: "section-title"
}
const _hoisted_11 = {
  id: "menu-running-elections",
  class: "running-elections-wrapper collapse in",
  "aria-expanded": "true"
}
const _hoisted_12 = {
  key: 0,
  class: "fa fa-exclamation-circle",
  style: {"color":"red"},
  "data-toggle": "tooltip",
  "data-container": "body",
  "data-placement": "right",
  title: "You have not voted on this issue."
}
const _hoisted_13 = {
  key: 1,
  id: "section-title"
}
const _hoisted_14 = {
  id: "menu-previous-elections",
  class: "previous-elections-wrapper collapse in",
  "aria-expanded": "true"
}
const _hoisted_15 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TMPLabel = _resolveComponent("TMPLabel")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("Eco Elections")), 1)
            ]),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("Select an election from the menu")), 1)
          ]),
          _hoisted_8,
          (_ctx.store.electionsLoaded && (_ctx.store.elections.past.length || _ctx.store.elections.running.length))
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_ctx.store.elections.running.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t("Running Elections")), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("ul", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.store.elections.running, (election) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: `election${election.Id}`
                    }, [
                      _createVNode(_component_router_link, {
                        to: `/election/${election.Id}`,
                        class: "running-election",
                        "data-guid": election.Id
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_TMPLabel, {
                            text: election.Name
                          }, null, 8, ["text"]),
                          (election.PendingVote)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_12))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["to", "data-guid"])
                    ]))
                  }), 128))
                ]),
                (_ctx.store.elections.past.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t("Previous Elections")), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("ul", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.store.elections.past, (election) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: `election${election.Id}`
                    }, [
                      _createVNode(_component_router_link, {
                        to: `/election/${election.Id}`,
                        class: "previous-election",
                        "data-guid": election.Id
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_TMPLabel, {
                            text: election.Name
                          }, null, 8, ["text"])
                        ]),
                        _: 2
                      }, 1032, ["to", "data-guid"])
                    ]))
                  }), 128))
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.$t("There have been no elections yet")), 1)
              ]))
        ])
      ])
    ])
  ]))
}